<div class="center-section" *ngIf="this.actRoute.snapshot.paramMap.get('id')">
    <tabset #staticTabs2 [class.nav-hiddennnn]="id" type="fill innertabs d-flex nav-justified mb-2">
        <tab *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="selectMenuItemTab(i, mn)">
            <ng-template tabHeading >
                <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/icons/{{mn.id == 'in_play' ? 'all' : mn.id}}.png">
                <span>{{mn.id == 'in_play' ? 'All' : mn.name}}</span>
            </ng-template>
            <!-- <h2 class="inner-title" >
                <img class="img-fluid" src="assets/images/icon/png/{{mn.id == 'in_play' ? 'stop-watch-in-play' : mn.id}}.png">
                {{mn.id == 'in_play' ? 'IN-PLAY' : mn.name}}
            </h2> -->
        </tab>
    </tabset>
</div>

<div class="list-container" *ngIf="data">
    <!-- inplay and sports -->
    <div class="list-content" *ngIf="!events.races.includes(eventId) || (eventId == 'in_play')">
        <div class="row align-items-center mx-lg-0 d-none d-sm-flex">
            <div class="col-md-3 col-8">
                match
            </div>
            <div class="col-md-2 col-4">
                state
            </div>
            <div class="col-md-7 col-12 px-0">
                <div class="odds-bl-head">
                    <div class="btn-group">
                        <button type="button" class="bl-btns">1</button>
                    </div>
    
                    <div class="btn-group">
                        <button type="button" class="bl-btns">X</button>
                    </div>
    
                    <div class="btn-group">
                        <button type="button" class="bl-btns">2</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="competition-row" *ngFor="let dt of data;trackBy:trackByIndex;">
            <!-- <div class="competition-head" *ngIf="dt?.name">
                <h3>{{dt?.name}}</h3>
            </div> -->
            <div class="row align-items-center mx-0" [routerLink]="['/event/detail', item.event_id]" *ngFor="let item of dt?.data;trackBy:trackByIndex;">
                <div class="col-md-3 col-8 align-items-center d-flex position-relative px-0">
                    <span class="fav-sports">
                        <img class="img-fluid" *ngIf="eventId == 'in_play'" src="https://speedcdn.io/assets/kesar-client/icons/{{item?.event_type_id}}.png">
                        <!-- <img class="img-fluid" src="assets/images/icon/png/star-red-inactive.png"> -->
                    </span>
                    <a href="javascript:void(0);">
                        <div class="two-teams">
                            <p *ngFor="let run of item?.runner;let rin=index;">
                                <!-- <b>{{rin + 1}}</b>  -->
                                {{run}}
                            </p>
                        </div>
                        <div class="two-teams" *ngIf="!item.name">
                            <p>{{item.market_name}}</p>
                        </div>
                        <em class="marketname">
                            {{item.fancy_active == 1 ? 'F' : ''}} 
                            {{item.bm_active == 1 ? 'BM' : ''}}
                            {{item.tv_channel != '' ? 'TV' : ''}}
                            {{item.custom_active != '' ? item.custom_active : ''}}
                        </em>
                    </a>
                </div>
                <div class="col-md-2 col-4 pr-1">
                    <span class="in-play" *ngIf="item.in_play == 1">in-play</span>
                    <span class="date-timer">{{(item.open_date_format) ? (item.open_date_format | date : 'dd-MM-YYY hh:mm a') : item.market_start_time_format | date : 'dd-MM-YYY hh:mm a'}} </span>
                </div>
                <div class="col-md-7 col-12 position-relative px-0">
                    <div class="odds-bl">
                        <div class="btn-group">
                            <button type="button" class="bl-btns blue {{odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.key}}">
                                {{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price : '-' }}
                                <span>{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.size) ? odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.size : '-' }}</span>
                            </button>
                            <button type="button" class="bl-btns red {{odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.key}}">
                                {{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price : '-' }}
                                <span>{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.size) ? odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.size : '-' }}</span>
                            </button>
                        </div>
                        <div class="btn-group">
                            <button type="button" class="bl-btns blue {{odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.key}}">
                                {{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price : '-' }}
                                <span>{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.size) ? odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.size : '-' }}</span>
                            </button>
                            <button type="button" class="bl-btns red {{odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.key}}">
                                {{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price : '-' }}
                                <span>{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.size) ? odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.size : '-' }}</span>
                            </button>
                        </div>
                        <div class="btn-group">
                            <button type="button" class="bl-btns blue {{odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.key}}">
                                {{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price : '-' }} 
                                <span>{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.size) ? odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.size : '-' }}</span>
                            </button>
                            <button type="button" class="bl-btns red {{odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.key}}">
                                {{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price : '-' }} 
                                <span>{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.size) ? odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.size : '-' }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-event-div" *ngIf="dt?.data.length == 0">
                <h2 class="no-event">NO EVENTS TO DISPLAY</h2>
            </div>
        </div>
    </div>
    <!-- races -->
    <div class="list-content" *ngIf="events.races.includes(eventId)">

        <tabset type="pills gray_tabs" *ngIf="events.races.includes(eventId)" class="Tabul-design">
            <tab [heading]="item?.event_country_code" *ngFor="let item of data;trackBy:trackByIndex;">
                <div class="bet-table position-relative horse-table">
                    <div class="horse-table-body">
                        <div class="horse-table-row" *ngFor="let rc of item?.data;trackBy:trackByIndex;">
                            <div class="bet-nation-name">
                                <div class="game-icon"><img src="https://speedcdn.io/assets/kesar-client/icons/television.svg"></div>
                                <div class="bet-nation-game-name"><span>{{rc?.event_name}}</span></div>
                            </div>
                            <div class="horse-time-detail">
                                <a *ngFor="let race of rc?.data;trackBy:trackByIndex;" href="javascript:void(0);"
                                    [routerLink]="['/event/detail', race?.event_id, race?.market_id]"><span
                                        class="">{{race?.market_start_time_format | date : 'HH:mm'}}</span></a>
                            </div>
                        </div>
                    </div>
                </div>

            </tab>
        </tabset>

        <div class="no-event-div" *ngIf="data.length == 0">
            <h2 class="no-event">NO EVENTS TO DISPLAY</h2>
        </div>

    </div>
    <!-- <div class="events-table-section" *ngIf="datalength == 0">
        <h2 class="no-event">NO EVENTS TO DISPLAY</h2>
    </div> -->
</div>